import React from 'react';
import favicon from '../assets/favicon.ico';
import previewFavicon from '../assets/favicon-preview.png';
import { graphql, useStaticQuery } from 'gatsby';
export const SEO = ({
    location,
    children,
}: {
    location: string;
    children?: any;
}) => {
    const { mediaImage: socialShareImgQuery } = useStaticQuery(graphql`
        query {
            mediaImage(name: { eq: "generic-social-share-image" }) {
                field_media_image {
                    alt
                }
                relationships {
                    field_media_image {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
    `);

    const socialShareImage =
        socialShareImgQuery?.relationships?.field_media_image?.localFile
            ?.publicURL;

    return (
        <>
            {children}
            <meta
                id="twitter:url"
                key="twitter-url"
                content={`https://www.spectrumreach.com${location}`}
            />
            {socialShareImage && (
                <meta
                    property="og:image"
                    content={`https://www.spectrumreach.com${socialShareImage}`}
                />
            )}
            {socialShareImage && (
                <meta
                    property="twitter:image"
                    content={`https://www.spectrumreach.com${socialShareImage}`}
                />
            )}
        </>
    );
};
